import { api } from "./client";

export type CancelAppointmentInput = {
  reasonCode: string;
  reasonNote?: string;
};

export type CancelAppointmentResponse = {
  cancelled: boolean;
  appointment?: {
    id: string;
    status: string;
    cancel_reason_code?: string;
    cancel_reason_note?: string | null;
    cancelled_at?: string;
  };
  message?: string;
};

export async function cancelAppointment(
  appointmentId: string,
  input: CancelAppointmentInput,
): Promise<CancelAppointmentResponse> {
  return api.post<CancelAppointmentResponse>(`/appointments/${appointmentId}/cancel`, {
    reasonCode: input.reasonCode,
    reasonNote: input.reasonNote,
  });
}

export type ReactivateAppointmentResponse = {
  reactivated: boolean;
  appointment?: {
    id: string;
    status: string;
    updated_at?: string;
  };
  message?: string;
};

export async function reactivateAppointment(appointmentId: string): Promise<ReactivateAppointmentResponse> {
  return api.post<ReactivateAppointmentResponse>(`/appointments/${appointmentId}/reactivate`, {});
}

export type DeleteAppointmentResponse = {
  deleted: boolean;
  appointment_id: string;
  starts_at?: string;
  ends_at?: string;
};

export async function deleteAppointment(appointmentId: string): Promise<DeleteAppointmentResponse> {
  return api.post<DeleteAppointmentResponse>(`/appointments/${appointmentId}/delete`, {});
}

export type SlotBusyVehicle = {
  vehicle_id: string;
  label: string;
  kind: "lesson" | "unavailable" | string;
};

export type SlotBusyVehiclesResponse = {
  busy_vehicles: SlotBusyVehicle[];
};

export async function fetchSlotBusyVehicles(input: {
  startsAt: string;
  endsAt: string;
  excludeAppointmentId?: string;
}): Promise<SlotBusyVehiclesResponse> {
  return api.post<SlotBusyVehiclesResponse>("/appointments/slot-busy-vehicles", {
    startsAt: input.startsAt,
    endsAt: input.endsAt,
    excludeAppointmentId: input.excludeAppointmentId,
  });
}
